import { Box, Skeleton, Stack, Typography } from "@mui/material";

/**
 * Loading placeholder for a facility-profile section (RCRA Profile, State
 * Information, …). Keeps the section header in place and renders a grid of
 * field-shaped skeletons so the content fades in instead of popping/jumping when
 * the facility query resolves.
 */
export function SectionSkeleton({ title, fieldCount = 6 }: { title: string; fieldCount?: number }) {
  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h6">{title}</Typography>
      </Stack>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", md: "repeat(3, 1fr)" },
          gap: 2,
        }}
      >
        {Array.from({ length: fieldCount }).map((_, index) => (
          <Stack key={index} spacing={0.5}>
            <Skeleton variant="text" width="40%" />
            <Skeleton variant="rounded" height={24} />
          </Stack>
        ))}
      </Box>
    </Box>
  );
}
